import React from 'react'

function SvgBriefCaseBlackIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="#667085"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.667"
        d="M6.667 17.5V5.833c0-.775 0-1.162.085-1.48A2.5 2.5 0 018.52 2.585C8.838 2.5 9.225 2.5 10 2.5s1.163 0 1.48.085a2.5 2.5 0 011.768 1.768c.086.318.086.705.086 1.48V17.5m-9 0h11.333c.933 0 1.4 0 1.757-.182.313-.16.568-.414.728-.728.182-.357.182-.823.182-1.757V8.5c0-.933 0-1.4-.182-1.757a1.667 1.667 0 00-.728-.728c-.357-.182-.824-.182-1.757-.182H4.334c-.934 0-1.4 0-1.757.182-.314.16-.569.415-.728.728-.182.357-.182.824-.182 1.757v6.333c0 .934 0 1.4.182 1.757.16.314.414.569.728.728.357.182.823.182 1.757.182z"
      ></path>
    </svg>
  )
}

export default SvgBriefCaseBlackIcon
